<template>
  <v-container fluid>
    <!-- 查询条件：日期（默认前一天）、车牌号（挂箱号合并查询）、车辆来源、位置 -->
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-menu ref="date_menu" v-model="date_menu" :close-on-content-click="false" :return-value.sync="queryForm.date"
          transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.date" label="日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.date" type="date" no-title value="YYYY-mm-DD" scrollable locale="zh-cn"
            @input="() => { $refs.date_menu.save(queryForm.date); date_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" label="车牌号/挂箱号" placeholder="车牌号/挂箱号" dense outlined clearable
          hide-details @keyup.enter="getdata()">
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-select v-model="queryForm.own_type" :items="own_types" label="车辆来源"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
        </v-select>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.location" label="位置" dense outlined clearable hide-details
          @keyup.enter="getdata()">
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <a-space>
          <v-btn @click="getdata()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
          <v-checkbox v-if="queryForm.query_type === 'using'" v-model="queryForm.empty" label="无任务"
            hide-details></v-checkbox>
          <v-btn v-if="queryForm.query_type === 'exception'" @click="download()" color="cyan" dark tile>
            <v-icon small>mdi-download</v-icon>导出
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <!-- 一级页签：异常（前一天未使用、空返车辆） / 使用情况（当前车辆列表） -->
    <a-tabs v-model="queryForm.query_type" size="small" @change="getdata()">
      <a-tab-pane key="exception" tab="异常"></a-tab-pane>
      <a-tab-pane key="using" tab="使用情况"></a-tab-pane>
    </a-tabs>
    <!-- 二级页签（仅"使用情况"显示）：车辆类型按牵引头/挂箱/载货车/临调展示，取值同运力监控大屏 -->
    <a-tabs v-if="queryForm.query_type === 'using'" v-model="queryForm.vehicletype" size="small" @change="getdata()">
      <a-tab-pane :key="1" tab="牵引头"></a-tab-pane>
      <a-tab-pane :key="2" tab="挂箱"></a-tab-pane>
      <a-tab-pane :key="3" tab="载货车"></a-tab-pane>
      <a-tab-pane :key="4" tab="临调"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <v-data-table dense :headers="headers" :items="list" :items-per-page="list.length" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height">
        <template v-slot:item.vehicle_number="{ item }">
          <span :class="{
            'text-h6 error--text': item.vehicle_number === '合计'
          }">
            {{ item.vehicle_number }}
          </span>
        </template>
        <template v-slot:item.vehicle_status="{ item }">
          <a-tag :class="item.vehicle_status_color">{{ item.vehicle_status }}</a-tag>
        </template>
        <template v-slot:item.vehicle_gnumber="{ item }">
          <span v-if="item.bind_vehicle_gnumber" :class="{
            'primary--text': item.brand === '徐工',
            'success--text': item.brand === '犀重',
            'error--text': item.brand === '一汽解放',
            'orange--text': item.brand === '陕汽',
          }">
            {{ item.bind_vehicle_gnumber }}
          </span>
          <span v-else>{{ item.vehicle_gnumber }}</span>
        </template>
        <template v-slot:item.waybills="{ item }">
          <div v-for="waybill in item.waybills" :key="waybill._id">
            <p> {{ waybill.postroute }} </p>
            <p> {{ waybill.block_time }} </p>
          </div>
        </template>
        <template v-slot:item.state_desc="{ item }">
          <p v-if="item.current_state_desc" :class="{
            'primary--text': item.brand === '徐工',
            'success--text': item.brand === '犀重',
            'error--text': item.brand === '一汽解放',
            'orange--text': item.brand === '陕汽',
          }">
            {{ item.current_state_desc }}
          </p>
          <p v-else>{{ item.state_desc }}</p>
          <p v-if="item.current_state_time_str" :class="{
            'primary--text': item.brand === '徐工',
            'success--text': item.brand === '犀重',
            'error--text': item.brand === '一汽解放',
            'orange--text': item.brand === '陕汽',
          }">
            {{ item.current_state_time_str }}
          </p>
          <p v-else>{{ item.state_time_str }}</p>
          <v-chip label small outlined v-if="item.current_state_update_from" :color="{
            '徐工': 'primary',
            '犀重': 'success',
            '一汽解放': 'error',
            '陕汽': 'orange',
          }[item.brand]">
            {{ item.current_state_update_from }}
          </v-chip>
          <p v-if="item.current_postline" :class="{
            'primary--text': item.brand === '徐工',
            'success--text': item.brand === '犀重',
            'error--text': item.brand === '一汽解放',
            'orange--text': item.brand === '陕汽',
          }">
            {{ item.current_postline }}
          </p>
          <p> {{ item.current_state_update_time }} </p>
        </template>
        <template v-slot:item.energy_consumption="{ item }">
          <span :class="{
            'success--text': queryForm.vehicletype === 1,
            'error--text': queryForm.vehicletype === 3,
          }">{{ item.energy_consumption }} {{ item.energy_unit }}</span>
        </template>
        <template v-slot:item.total_cost="{ item }">
          <span v-if="item.total_cost" :class="{
            'success--text': queryForm.vehicletype === 1,
            'error--text': queryForm.vehicletype === 3,
          }">{{ item.total_cost }} 元</span>
        </template>
        <template v-slot:item.avg_price="{ item }">
          <span :class="{
            'success--text': queryForm.vehicletype === 1,
            'error--text': queryForm.vehicletype === 3,
          }">{{ item.avg_price }} {{ item.price_unit }}</span>
        </template>
        <template v-slot:item.location="{ item }">
          <p v-if="item.location">{{ item.location.address }}</p>
          <p>{{ item.location_time }}</p>
        </template>
        <template v-slot:item.own_type_name="{ item }">
          <span v-if="item.own_type_name" :style="{
            'color': $utils.textToBgColor(item.own_type_name)
          }">{{ item.own_type_name }}</span>
        </template>
        <template v-slot:item.exception_desc="{ item }">
          <v-chip v-if="item.exception_desc" label small outlined :color="item.exception_color">
            {{ item.exception_desc }}
          </v-chip>
        </template>
        <template v-slot:item.cost="{ item }">
          <span :class="{
            'text-h6 error--text': item.vehicle_number === '合计'
          }">
            {{ item.cost }}
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import ExcelJS from 'exceljs';

export default {
  name: "RunningTable",
  data() {
    return {
      date_menu: false,
      // 查询条件：日期（默认前一天）、车牌号（挂箱号合并在一起查询）、车辆来源、位置
      queryForm: {
        date: this.$moment().subtract(1, "day").format("YYYY-MM-DD"),
        vehicle_number: "",
        own_type: null, // 车辆来源：1 自有车 / 3 包车 / 2 临调车，null 为全部
        location: "",
        // 一级页签：exception 异常 / using 使用情况
        query_type: "using",
        // 二级车辆类型页签，取值同运力监控大屏 /map/list2：1 牵引头 2 挂箱 3 载货车 4 临调
        vehicletype: 1,
        empty: false,
      },
      // 车辆来源下拉（自有车、包车、临调车只作为属性，不再作为车辆类型页签）
      own_types: [
        { value: 1, text: "自有车" },
        { value: 3, text: "包车" },
        { value: 2, text: "临调" },
      ],
      headers: [],
      list: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  mounted() {
    // 查询行 + 两级页签，表格高度多预留一些
    this.height = window.innerHeight - 260;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 260;
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/runningtable/list", this.queryForm).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (this.queryForm.query_type === "using") {
            this.list = res.data.list.map((n, i) => ({ ...n, index: i + 1 }));
            this.headers = this.buildUsingHeaders();
          }
          else {
            this.list = [
              ...(res.data.list.length > 1 ? [
                (() => {
                  let cost = res.data.list.reduce((a, b) => a.plus(b.cost || 0), this.$d()).toString();
                  return { vehicle_number: "合计", cost, fcost: this.$utils.formatMoney(cost, 2, '') };
                })()
              ] : []),
              ...res.data.list.map((n, i) => ({ ...n, index: i + 1 })),
            ];
            this.headers = this.buildExceptionHeaders();
          }
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    // 使用情况：当前车辆列表，增加能耗、总费用、均价
    buildUsingHeaders() {
      return [
        { text: "序号", value: "index", width: 80, align: "center" },
        ...(this.queryForm.vehicletype !== 2 ? [
          { text: "车牌号", value: "vehicle_number", width: 100, align: "center" },
        ] : []),
        ...(this.queryForm.vehicletype === 1 ? [
          { text: "车辆状态", value: "vehicle_status", width: 100, align: "center" },
          { text: "电量", value: "soc", width: 100, align: "center" },
        ] : []),
        { text: "挂箱号", value: "vehicle_gnumber", width: 100, align: "center" },
        { text: "里程", value: "mileage", width: 100, align: "center" },
        { text: "车辆类型", value: "vehicle_type", width: 100, align: "center" },
        { text: "车辆来源", value: "own_type_name", width: 100, align: "center" },
        { text: "执行邮路", value: "waybills", width: 160, align: "center" },
        ...(this.queryForm.vehicletype !== 4 ? [
          { text: "最新状态", value: "state_desc", width: 160, align: "center" },
        ] : []),
        { text: "最新状态", value: "location", width: 150, align: "center" },
        // 按所选日期统计；字段名为前后端约定占位，联调后如不同直接改
        ...((this.queryForm.vehicletype === 1 || this.queryForm.vehicletype === 3) ? [
          { text: "能耗", value: "energy_consumption", width: 100, align: "center" },
          { text: "总费用", value: "total_cost", width: 100, align: "center" },
          { text: "均价", value: "avg_price", width: 100, align: "center" },
        ] : []),
        ...((this.queryForm.vehicletype !== 2) ? [
          { text: "收入(元)", value: "income", width: 100, align: "center" },
        ] : []),
      ];
    },
    // 异常：前一天未使用的车辆、空返的车辆；exception_desc 为异常类型（未使用/空返）
    buildExceptionHeaders() {
      return [
        { text: "序号", value: "index", width: 80, align: "center" },
        { text: "车牌号", value: "vehicle_number", width: 100, align: "center" },
        { text: "挂箱号", value: "vehicle_gnumber", width: 100, align: "center" },
        { text: "车辆类型", value: "vehicle_type", width: 100, align: "center" },
        { text: "车辆来源", value: "own_type_name", width: 100, align: "center" },
        { text: "异常类型", value: "exception_desc", width: 100, align: "center" },
        { text: "成本", value: "cost", width: 100, align: "center" },
        { text: "位置", value: "location", width: 200, align: "center" },
        // { text: "备注", value: "remark", width: 200, align: "center" },
      ];
    },
    async download() {
      let rows = [
        [
          "序号",
          "车牌号",
          "挂厢号",
          "车辆类型",
          "车辆来源",
          "异常类型",
          "成本",
          "最新位置",
          "更新时间",
        ],
        ...this.list.map((n, i) => [
          ++i,
          n.vehicle_number || '',
          n.vehicle_gnumber || '',
          n.own_type_name || '',
          n.vehicle_type || '',
          n.exception_desc || '',
          Number(n.cost) || '',
          n.location?.address || '',
          n.location_time || '',
        ]),
      ];
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');
      worksheet.addRows(rows);
      const buffer = await workbook.xlsx.writeBuffer();
      this.$utils.downloadBlob([buffer], "application/octet-stream", `异常车辆.xlsx`);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/* 两级页签紧贴，减少多余间距 */
/deep/ .ant-tabs-bar {
  margin-bottom: 0;
}

p {
  margin: 0;
}
</style>
